export const getInsuranceCompanies = (state) => state.insuranceCompanies.insuranceCompanies;
